import { showModalError } from './modal';
import { t } from './lang';

class ErrorHandler {
  static getErrorData(err) {
    return err;
  }

  static isEqualToCode(err, code) {
    const errData = this.getErrorData(err);
    return errData && errData.code === code;
  }

  static showError(err, options = {}) {
    const initOptions = { onOk: () => {}, title: 'Error!' };
    options = { ...initOptions, ...options };
    const { onOk, title } = options;
    const errData = this.getErrorData(err);
    if (errData && errData.message) {
      var translatedMessage = t(`error.message.${errData?.code}`, errData.errorparameters) || errData.message;
      showModalError({
        title,
        content: translatedMessage || 'You\'re having problems with your network connection. Please try again.',
        onOk,
        okText: t('common.ok'),
      });
    }
  }
}

export default ErrorHandler;
